import React from "react"
import {ReadyToLaunchCard} from "../../../containers/ReadyToLaunchCard/ReadyToLaunchCard"
import {TaskCardList} from "../../TaskCardList/TaskCardList"
import {TaskCardItem} from "../../TaskCard/types"
import classNames from "classnames"

interface GettingStartedCardProps {
	tasks: TaskCardItem[]
	className?: string
}

export function GettingStartedCard({tasks, className}: GettingStartedCardProps) {
	return (
		<ReadyToLaunchCard
			title="Getting started"
			className={classNames("ready-to-launch-card-getting-started", className)}
			backgroundClassName="getting-started-card-bg"
			withShadow
		>
			<TaskCardList tasks={tasks} />
		</ReadyToLaunchCard>
	)
}
